import React from "react";
import { SmartApplyTemplate } from "../../../../template/smart-apply/default-template";
import { FormContainer, Spinner } from "@graffer-inc/console-design-kit";
import { useProcedureAssignmentSettingRuleSet } from "./hooks";
import { SmartApplyMenuList } from "../../../../organisms/smart-apply/menu-list";
import { RulesetBasicInfo } from "./rulesetsBasicInfo";
import { TargetFields } from "./targetFields";
import { Rules } from "./rules";

type BaseProps = ReturnType<typeof useProcedureAssignmentSettingRuleSet>;

interface AdditionalProps {
  contentsHeader: React.ReactElement;
}

type ProcedureAssignmentSettingRulesetPresenterProps = BaseProps &
  AdditionalProps;

const ProcedureAssignmentSettingRulesetPresenter: React.FC<
  ProcedureAssignmentSettingRulesetPresenterProps
> = ({
  rulesetName,
  setRulesetName,
  description,
  setDescription,
  targetFields,
  rules,
  editingField,
  setEditingField,
  groupMaps,
  isLoading,
  isTargetFieldUsedInRules,
  nameErrorMessages,
  descriptionErrorMessages,
  targetFieldsError,
  rulesError,

  handleSaveRule,
  handleDeleteRule,
  handleSaveField,
  handleDeleteField,
  contentsHeader,
}) => {
  return (
    <SmartApplyTemplate
      breadcrumbs={[]}
      menuList={<SmartApplyMenuList />}
      contentsHeader={contentsHeader}
    >
      <FormContainer>
        <RulesetBasicInfo
          rulesetName={rulesetName}
          setRulesetName={setRulesetName}
          description={description}
          setDescription={setDescription}
          nameErrorMessages={nameErrorMessages}
          descriptionErrorMessages={descriptionErrorMessages}
        />
        <TargetFields
          targetFields={targetFields}
          editingField={editingField}
          setEditingField={setEditingField}
          handleDeleteField={handleDeleteField}
          handleSaveField={handleSaveField}
          isTargetFieldUsedInRules={isTargetFieldUsedInRules}
          errorMessage={targetFieldsError}
        />
        <div style={{ marginBottom: "16px" }}>
          <Rules
            rules={rules}
            targetFields={targetFields}
            groupMaps={groupMaps}
            handleDeleteRule={handleDeleteRule}
            handleSaveRule={handleSaveRule}
            errorMessage={rulesError}
          />
        </div>
      </FormContainer>
      <Spinner loading={isLoading} />
    </SmartApplyTemplate>
  );
};

export default ProcedureAssignmentSettingRulesetPresenter;
